module.exports = __webpack_public_path__ + "img/img51.9e6de9ec.svg";